import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { LanguageContext, SettingsContext } from "../../../core/store";
import { SettingsOptions } from "../../../core/config/global-settings";

import Selectbox from "../../Selectbox";

import { Row } from "../../../core/styles";
import { Panel, Label, FormElement, SettingsTitle, CheckboxWrapper, CheckBox, CheckMark } from "../style";
import { ToggleSwitchWrapper, Switch, SwitchButton } from "../../Header/style";

const PageSettings = (overrideSettings) => {

    const { translate } = useContext(LanguageContext);

    const pathName = window.location.pathname;
    const { pageChangeTime, matchTimeRange, fontSize, goalEffect } = SettingsOptions.options;

    let isActiveSettings = {
        fontSize: fontSize.isActive,
        pageChangeTime: pageChangeTime.isActive,
        matchTimeRange: matchTimeRange.isActive,
        goalEffect: goalEffect.isActive
    };

    if (Object.keys(overrideSettings).length > 0) {
        isActiveSettings = {
            ...isActiveSettings,
            ...overrideSettings
        };
    }

    const { settingsState, dispatch } = useContext(SettingsContext);
    const [currentFontSize, setCurrentFontSize] = useState();

    const initialValues = settingsState && settingsState.global.initialValues;

    const getPage = settingsState.pageList.filter((page) => {
        return page.path === pathName;
    });

    const newInitialValues = getPage.length > 0 ? getPage[0].settings : initialValues;

    const [formValues, setFormValues] = useState(newInitialValues);

    const saveContext = () => {
        if (getPage.length === 0) {
            let action = {
                type: "CREATE_PAGE_SETTINGS",
                payload: {
                    path: pathName,
                    settings: formValues
                }
            };

            dispatch(action);
        } else {
            const currentPage = getPage[0];
            const currentPageIndex = settingsState.pageList.indexOf(currentPage);

            let action = {
                type: "UPDATE_PAGE_SETTINGS",
                payload: {
                    currentPageIndex: currentPageIndex,
                    settings: formValues
                }
            };

            dispatch(action);
        }
    };

    const handleChange = change => {
        setFormValues({
            ...formValues,
            [change.name || change.target.name]: change.value || change.target.checked
        });
    };

    const handleFontSizeChange = () => {
        const [small, big] = fontSize.options;

        setFormValues({
            ...formValues,
            fontSize: formValues.fontSize === small.value ? big.value : small.value
        });

        setCurrentFontSize(formValues.fontSize === small.value ? "isBig" : "isSmall");

    };

    useEffect(() => {
        const [small] = fontSize.options;
        setCurrentFontSize(formValues.fontSize === small.value ? "isSmall" : "isBig");
        saveContext();
    }, [formValues]);

    return (
        <Row noPadding>
            <Panel>
                <SettingsTitle>{translate("utils.settings")}</SettingsTitle>

                {isActiveSettings.fontSize && <FormElement>
                    <Label>{translate("utils.fontSize")}</Label>
                    <ToggleSwitchWrapper>
                        <Switch onClick={() => handleFontSizeChange()}>
                            <SwitchButton size={currentFontSize}/>
                        </Switch>
                    </ToggleSwitchWrapper>
                </FormElement>}

                {isActiveSettings.pageChangeTime && <FormElement>
                    <Label>{translate("utils.pageChangeTime")}</Label>
                    <Selectbox
                        name="pageChangeTime"
                        selectedList={formValues.pageChangeTime}
                        settingsInfo={pageChangeTime.options}
                        itemValue={translate("utils.pageChangeTimeLabel")}
                        onSelected={(e) => handleChange(e)}
                    />
                </FormElement>}

                {isActiveSettings.matchTimeRange && <FormElement>
                    <Label>{translate("utils.matchTimeRange")}</Label>
                    <Selectbox
                        name="matchTimeRange"
                        settingsInfo={matchTimeRange.options}
                        selectedList={formValues.matchTimeRange}
                        itemValue={translate("utils.matchTimeRangeLabel")}
                        onSelected={(e) => handleChange(e)}
                    />
                </FormElement>}

                {isActiveSettings.goalEffect && <FormElement>
                    <Label htmlFor="chGoalSound">{translate("utils.goalSound")}</Label>
                    <CheckboxWrapper>
                        <CheckBox name="goalEffect"
                                  id="chGoalSound"
                                  type="checkbox"
                                  checked={formValues.goalEffect}
                                  onChange={handleChange}/>
                        <CheckMark/>
                    </CheckboxWrapper>
                </FormElement>}
            </Panel>
        </Row>
    );
};

PageSettings.propTypes = {
    overrideSettings: PropTypes.object
};

export default PageSettings;
